import request from '@/utils/request';

//获取企业所有坐席列表
export function getSeatsList() {
  return request({
    url: '/api/com_all_zuoxi_list',
    method: 'post',
  })
}
//获取线索列表
export function getCluesList(data) {
    return request({
        url:'/api/customer_clue_list',
        method:'post',
        data
    })
}
//获取批量导入线索模板
export function getCluesTemplate() {
    return request({
        url:'/api/customer_clue_tem_url',
        method:'post',
    })
}
//线索详情
export function cluesDetail(data) {
    return request({
        url:'/api/customer_clue_info',
        method:'post',
        data
    })
}
//线索详情跟进记录
export function cluesRecord(data) {
    return request({
        url:'/api/customer_clue_remark_list',
        method:'post',
        data
    })
}
//线索详情通话记录
export function cluesCallRecord(data) {
    return request({
        url:'/api/customer_clue_tonghua_list',
        method:'post',
        data
    })
}
//线索删除
export function deleteClues(data) {
    return request({
        url:'/api/customer_clue_delete',
        method:'post',
        data
    })
}
//添加跟进记录
export function addFollowUpRecord(data) {
    return request({
        url:'/api/customer_clue_record_add',
        method:'post',
        data
    })
}
//坐席拨号
export function callSeat(data) {
    return request({
        url:'/api/customer_clue_zuoxi_dial',
        method:'post',
        data
    })
}
//全部通话记录
export function allCallRecord(data) {
    return request({
        url:'/api/customer_all_tonghua_list',
        method:'post',
        data
    })
}
//通话统计
export function callStatisticsData(data) {
    return request({
        url:'/api/customer_clue_statistics',
        method:'post',
        data
    })
}
//修改跟进状态
export function editFollowUpStatus(data) {
    return request({
        url:'/api/customer_clue_upd_status',
        method:'post',
        data
    })
}
//线索标签回显
export function getCluesLabel(data) {
    return request({
        url:'/api/customer_clue_tag_detail',
        method:'post',
        data
    })
}
//提交标签 跟进状态 跟进记录
export function submitCluesLabel(data) {
    return request({
        url:'/api/customer_clue_save_tagetc',
        method:'post',
        data
    })
}